import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

interface ProgressSeparatorProps {
  isActive: boolean
}

export const ProgressSeparator = styled.div<ProgressSeparatorProps>`
  flex-grow: 1;
  height: 2px;
  margin-inline: ${Spacing.S12};
  position: relative;
  background-color: ${Color.Grey200};
  overflow: hidden;

  &::before {
    content: '';
    width: ${({ isActive }) => (isActive ? '100%' : '0%')};
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: ${Color.Black};
    transition: width 0.4s ease-in-out;
  }
`

export const StepContainer = styled.div`
  position: relative;
`

export const StepLabel = styled.span`
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  transition: color 0.3s ease-in-out;
`
